export default {
  navigationBarTitleText: '店铺'
}
